import { NavLink, Outlet } from 'react-router-dom';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import TutorialButton from '../../tutorial/components/TutorialButton';

const HELP_SUPPORT_MAILTO =
    'mailto:loyalpassapp@gmail.com?subject=LoyalPass%20-%20Help%20%26%20Support';

export default function SettingsLayout() {
    const tabs = [
        { name: 'General', path: '/dashboard/settings/general' },
        { name: 'Android Pass', path: '/dashboard/settings/android-pass' },
        { name: 'Apple Pass', path: '/dashboard/settings/apple-pass' },
        { name: 'Rewards Settings', path: '/dashboard/settings/global-rewards' },
        { name: 'Membership', path: '/dashboard/settings/membership' },
    ];

    return (
        <div className="min-h-screen bg-gray-300 p-4 sm:p-8">
            <div className="max-w-5xl mx-auto">
                <div className="mb-6 flex flex-wrap items-center justify-between gap-2 sm:gap-4 border-b pb-4">
                    <div className="flex flex-wrap gap-2 sm:gap-4">
                    {tabs.map((tab) => (
                        <NavLink
                            key={tab.name}
                            to={tab.path}
                            end
                            className={({ isActive }) =>
                                `px-3 py-2 text-sm sm:text-md font-semibold ${
                                    isActive
                                        ? 'border-b-2 border-primary text-primary'
                                        : 'text-gray-500 hover:text-dark'
                                }`
                            }
                        >
                            {tab.name}
                        </NavLink>
                    ))}
                    </div>
                    <TutorialButton />
                </div>

                <Outlet />
            </div>

            <a
                href={HELP_SUPPORT_MAILTO}
                title="Help & Support"
                aria-label="Help and support"
                className="fixed bottom-5 right-5 z-40 inline-flex items-center justify-center rounded-full border border-gray-200 bg-white p-3 text-primary shadow-md transition hover:border-primary hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
                <QuestionMarkCircleIcon className="h-6 w-6 shrink-0" aria-hidden />
            </a>
        </div>
    );
}
